"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var images_1 = require("../../images");
function CaseCard(props) {
    var style = props.style, className = props.className, title = props.title, describe = props.describe, source = props.source, backgroundUrl = props.backgroundUrl, link = props.link, logoUrl = props.logoUrl, onClick = props.onClick, extendProps = props.extendProps;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    function renderLink() {
        if (!link) {
            return null;
        }
        var text = link.text, to = link.to, extendProps = link.extendProps;
        return (react_1.default.createElement("a", __assign({ href: to }, extendProps, { className: "case-link" }),
            text,
            " >"));
    }
    function renderContainer() {
        return (react_1.default.createElement("section", { className: "case-container" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("img", { className: "case-logo", src: logoUrl }),
                react_1.default.createElement("h2", { className: "case-title" }, title),
                react_1.default.createElement("p", { className: "case-desc" }, describe)),
            renderLink()));
    }
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)("".concat(classPrefix, "-case-card"), className) },
        react_1.default.createElement(images_1.ImageVideo, { source: source, backgroundUrl: backgroundUrl, onClick: onClick, extendProps: extendProps }),
        renderContainer()));
}
exports.default = CaseCard;
//# sourceMappingURL=CaseCard.js.map